<div class="loading-centered">
  <div class="loading-container" [class.with-box]="context.withBox">
    <div class="loading-content">
      <div class="spinner-container">
        <mat-spinner diameter="35" strokeWidth="6" color="accent"></mat-spinner>
      </div>
      <span>{{ context.message }}</span>
    </div>
  </div>
</div>
